<template>
  <div class="ob1-cancel-promotional-code ml-lg-1">
    <wptv-icon-link
      :label="label"
      :sr-label="label"
      :icon-name="'icon-delete'"
      to=""
      :dark-mode="darkMode"
      data-wptv="coupon-desactiver"
      @click.native="actionCb" />
  </div>
</template>

<script>
import WptvIconLink from '../../../iconLink/IconLink.vue'

export default {
  name: 'PromotionalCodeButtonCancel',
  components: {
    WptvIconLink
  },
  props: {
    darkMode: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    actionCb: {
      type: Function,
      required: true
    }
  }
}
</script>
